angular.module('zc.zenclerkS')
  .factory('ZcsInvoice', zcsInvoice);

zcsInvoice.$inject = ['FacadeV2'];
function zcsInvoice(FacadeV2) {
  return class ZcsInvoice {
    static all(apikey) {
      return FacadeV2.request(`/apikeys/${apikey}/zcs_invoices/`)
        .then(res => res.data);
    }

    static find(apikey, term) {
      return FacadeV2.request(`/apikeys/${apikey}/zcs_invoices/${term}`, {})
        .then(res => res.data);
    }

    static generateDemoData() {
      return {
        new_client: true,
        consumption_tax: 680,
        discount: 2,
        fee_rate: 0.05,
        invoice_price: 9180,
        invoice_price_tax_excluded: 8500,
        max_invoice: 30000,
        monthly_total_conversion: 3924191,
        total_campaign_price: 170057,
        details: [{
          _id: '1234',
          conversion_count: 8,
          device: 'pc',
          invoice: 5846,
          total: 116922
        },
        {
          _id: '1234',
          conversion_count: 6,
          device: 'other',
          invoice: 2656,
          total: 53135
        }
        ]
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/invoice.service.js